<!--
 * @Description: Jerry Create File
 * @Version: 1.0
 * @Autor: Jerry
 * @Date: 2021-12-01 09:13:18
 * @LastEditors: lt
 * @LastEditTime: 2022-01-27 14:46:36
-->

<template>
  <el-dialog
    :visible.sync="dialogStatus"
    width="540px"
    top="0"
    class="dialog-receive-successed  "
    :show-close="false"
  >

    <div class=" animate__animated animate__swing">
      <div v-if="currentStepStatus===1" class="step-1">
        <img class="close" :src="require('../assets/activitys/20211130/close.png')" alt="" @click="dialogStatus=false">
        <img class="btn" :src="require('../assets/activitys/20211130/btn-1.png')" alt="" @click="setStatus()">
      </div>
      <div v-if="currentStepStatus===2" class="step-2">
        <div class="mid-box">
          <!-- <img v-for="(val,idx) in imgs" :key="idx" :src="val.url" alt=""> -->
          <img src="https://yyyupdate.oss-cn-shanghai.aliyuncs.com/cmsImage/new_customer_coupon.png" alt="">
        </div>
        <img class="btn" :src="require('../assets/activitys/20211130/btn-2.png')" alt="" @click="goCheckLists()">

      </div>

    </div>
  </el-dialog>

</template>
<script>
export default {
  name: 'NewCustomerActivity',
  data() {
    return {
      dialogStatus: false,
      currentStepStatus: 1,
      imgs: [
        { url: require('../assets/activitys/20211130/coupon1.png') },
        { url: require('../assets/activitys/20211130/coupon2.png') },
        { url: require('../assets/activitys/20211130/coupon3.png') },
        { url: require('../assets/activitys/20211130/coupon4.png') },
        { url: require('../assets/activitys/20211130/coupon5.png') },
        { url: require('../assets/activitys/20211130/coupon6.png') },
        { url: require('../assets/activitys/20211130/coupon7.png') },
        { url: require('../assets/activitys/20211130/coupon8.png') },
        { url: require('../assets/activitys/20211130/coupon9.png') }
      ],
      customerId: null,
      flag: true
    }
  },
  mounted() {
    setTimeout(this.loadData, 500)
  },
  methods: {
    /** 加载活动 */
    async loadData() {
      const CustomerId = this.auth.getLoginDatas()
      if (!CustomerId) {
        this.$message.error('未登录')
        return
      }
      const res = await this.getAction(
        '/api_coupons/CouponLive/IsGetNewMainCoupons'
      )
      if (!res.IsSuccess) {
        return
      }
      if (res.Data) {
        this.dialogStatus = true
      }
    },
    async setStatus() {
      if (this.flag) {
        this.flag = false
        const res = await this.getAction(
          '/api_coupons/CouponLive/SendNewMainCoupons'
        )
        if (res.Data) {
          this.currentStepStatus = 2
        } else {
          this.flag = true
        }
      }
    },
    goCheckLists() {
      this.$router.push({
        name: 'MyCoupon'
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import url("./style/NewCustomerActivity.less");
</style>
